import { EnumTypeValue } from "@/shared/types";

export type Filter = {
    type: FilterType;
    active: boolean;
    order: number;
};

export const FilterType = {
    ALL: "Alle",
    SPOORWEB: "Spoorweb",
    RCB: "Regiecentrum Bus",
    REGIEVOERDER: "Regievoerder",
    KLANTENSERVICE: "Klantenservice",
    BERICHTEN: "Berichten",
} as const;
export type FilterType = EnumTypeValue<typeof FilterType>;

export const initialFilters: Filter[] = [
    { type: FilterType.ALL, active: true, order: 1 },
    { type: FilterType.SPOORWEB, active: false, order: 2 },
    { type: FilterType.RCB, active: false, order: 3 },
    { type: FilterType.REGIEVOERDER, active: false, order: 4 },
    { type: FilterType.KLANTENSERVICE, active: false, order: 5 },
    { type: FilterType.BERICHTEN, active: false, order: 6 },
];
